// src/components/pages/sports/Partials/CulturalSection.jsx
import React, { useEffect } from "react";
import Slider from "react-slick";
import GLightbox from "glightbox";
import "glightbox/dist/css/glightbox.css";

const outerSettings = {
  infinite: true,
  speed: 500,
  arrows: true,
  dots: false,
  rows: 2,
  slidesPerRow: 1,
  slidesToShow: 1,
  slidesToScroll: 2,
  responsive: [
    {
      breakpoint: 641,
      settings: { slidesToShow: 1, slidesToScroll: 1, rows: 2 },
    },
    {
      breakpoint: 900,
      settings: { slidesToShow: 2, slidesToScroll: 2, rows: 2 },
    },
  ],
  nextArrow: <div className="swiper-button-next" />,
  prevArrow: <div className="swiper-button-prev" />,
};

const innerImageSettings = {
  dots: false,
  infinite: false,
  speed: 400,
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  adaptiveHeight: true,
};

const CulturalSection = ({ culturalSection }) => {
  useEffect(() => {
    GLightbox({ selector: ".glightbox", touchNavigation: true, loop: true });
  }, []);

  if (!culturalSection) return null;

  const slides = culturalSection.slides || [];

  // ⭐ GROUP slides in PAIRS: [text, images]
  const pairedSlides = [];
  for (let i = 0; i < slides.length; i += 2) {
    pairedSlides.push({
      text: slides[i],
      images: slides[i + 1],
    });
  }

  return (
    <section className="cultural-section">
      <div className="container">
        <div className="sec-title text-center">
          <h2>{culturalSection.heading}</h2>
        </div>

        <Slider {...outerSettings} className="cultural_events-carousel">
          {pairedSlides.map((pair, index) => {
            const isEven = index % 2 === 0; // alternate layout

            return (
              <div className="combined-slide" key={index}>
                <div className="d-flex justify-content-center">
                  {/* ================= MOBILE VIEW — ALWAYS TEXT ABOVE IMAGES ================= */}
                  <div className="d-block d-md-none w-100">
                    {/* TEXT FIRST */}
                    {pair.text?.type === "text" && (
                      <div className="sub-event mb-0 mb-md-3">
                        <p className="text-start">
                          <span className="side-heading-size">
                            {pair.text.title}
                          </span>

                          {pair.text.date && (
                            <>
                              <br />
                              <img
                                src="/assets/images/calendar.webp"
                                className="info-icon"
                              />
                              {pair.text.date}
                            </>
                          )}
                          {pair.text.time && (
                            <>
                              <br />
                              <img
                                src="/assets/images/clock.webp"
                                className="info-icon"
                              />
                              {pair.text.time}
                            </>
                          )}
                          {pair.text.venue && (
                            <>
                              <br />
                              <img
                                src="/assets/images/location.webp"
                                className="info-icon"
                              />
                              {pair.text.venue}
                            </>
                          )}
                        </p>
                      </div>
                    )}

                    {/* IMAGES BELOW */}
                    {pair.images?.type === "images" && (
                      <div className="cultural-carousel mb-4">
                        <Slider {...innerImageSettings}>
                          {pair.images.images.map((img, i) => (
                            <div className="item" key={i}>
                              <a
                                href={`${process.env.REACT_APP_API_URL}/public${img}`}
                                className="glightbox"
                                data-gallery={pair.images.gallery}
                              >
                                <div className="img-wrapper">
                                  <img
                                    src={`${process.env.REACT_APP_API_URL}/public${img}`}
                                    className="img-fluid"
                                  />
                                  <span class="overlay-icon">
                                    <i class="fa fa-plus"></i>
                                  </span>
                                </div>
                              </a>
                            </div>
                          ))}
                        </Slider>
                      </div>
                    )}
                  </div>

                  {/* ================= DESKTOP VIEW — KEEP ORIGINAL LAYOUT ================= */}
                  <div className="d-none d-md-flex w-100">
                    {isEven ? (
                      <>
                        {/* LEFT TEXT */}
                        <div className="col-md-6 px-0">
                          {pair.text?.type === "text" && (
                            <div className="sub-event">
                              <p className="text-start">
                                <span className="side-heading-size">
                                  {pair.text.title}
                                </span>

                                {pair.text.date && (
                                  <>
                                    <br />
                                    <img
                                      src="/assets/images/calendar.webp"
                                      className="info-icon"
                                    />
                                    {pair.text.date}
                                  </>
                                )}
                                {pair.text.time && (
                                  <>
                                    <br />
                                    <img
                                      src="/assets/images/clock.webp"
                                      className="info-icon"
                                    />
                                    {pair.text.time}
                                  </>
                                )}
                                {pair.text.venue && (
                                  <>
                                    <br />
                                    <img
                                      src="/assets/images/location.webp"
                                      className="info-icon"
                                    />
                                    {pair.text.venue}
                                  </>
                                )}
                              </p>
                            </div>
                          )}
                        </div>

                        {/* RIGHT IMAGES */}
                        <div className="col-md-6 px-0">
                          {pair.images?.type === "images" && (
                            <div className="cultural-carousel">
                              <Slider {...innerImageSettings}>
                                {pair.images.images.map((img, i) => (
                                  <div className="item" key={i}>
                                    <a
                                      href={`${process.env.REACT_APP_API_URL}/public${img}`}
                                      className="glightbox"
                                      data-gallery={pair.images.gallery}
                                    >
                                      <div className="img-wrapper">
                                        <img
                                          src={`${process.env.REACT_APP_API_URL}/public${img}`}
                                          className="img-fluid"
                                        />
                                        <span class="overlay-icon">
                                          <i class="fa fa-plus"></i>
                                        </span>
                                      </div>
                                    </a>
                                  </div>
                                ))}
                              </Slider>
                            </div>
                          )}
                        </div>
                      </>
                    ) : (
                      <>
                        {/* LEFT IMAGES */}
                        <div className="col-md-6 px-0">
                          {pair.images?.type === "images" && (
                            <div className="cultural-carousel">
                              <Slider {...innerImageSettings}>
                                {pair.images.images.map((img, i) => (
                                  <div className="item" key={i}>
                                    <a
                                      href={`${process.env.REACT_APP_API_URL}/public${img}`}
                                      className="glightbox"
                                      data-gallery={pair.images.gallery}
                                    >
                                      <div className="img-wrapper">
                                        <img
                                          src={`${process.env.REACT_APP_API_URL}/public${img}`}
                                          className="img-fluid"
                                        />
                                        <span class="overlay-icon">
                                          <i class="fa fa-plus"></i>
                                        </span>
                                      </div>
                                    </a>
                                  </div>
                                ))}
                              </Slider>
                            </div>
                          )}
                        </div>

                        {/* RIGHT TEXT */}
                        <div className="col-md-6 px-0">
                          {pair.text?.type === "text" && (
                            <div className="sub-event">
                              <p className="text-start">
                                <span className="side-heading-size">
                                  {pair.text.title}
                                </span>

                                {pair.text.date && (
                                  <>
                                    <br />
                                    <img
                                      src="/assets/images/calendar.webp"
                                      className="info-icon"
                                    />
                                    {pair.text.date}
                                  </>
                                )}
                                {pair.text.time && (
                                  <>
                                    <br />
                                    <img
                                      src="/assets/images/clock.webp"
                                      className="info-icon"
                                    />
                                    {pair.text.time}
                                  </>
                                )}
                                {pair.text.venue && (
                                  <>
                                    <br />
                                    <img
                                      src="/assets/images/location.webp"
                                      className="info-icon"
                                    />
                                    {pair.text.venue}
                                  </>
                                )}
                              </p>
                            </div>
                          )}
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </div>
            );
          })}
        </Slider>
      </div>
    </section>
  );
};

export default CulturalSection;
